var map = {
	"./custom.svg": 50732,
	"./fencing.svg": 60956,
	"./gutters.svg": 79936,
	"./house.svg": 83744,
	"./restoration.svg": 36164,
	"./roof.svg": 51620,
	"./siding.svg": 43028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18188;